import { useStatusBarSurface } from '@/hooks/use-status-bar-surface';
import { brandCanvasClass } from '@/components/brand/entry-styles';

import type { ReactNode } from 'react';

interface MobileAuthLayoutProps {
  readonly children: ReactNode;
}

/**
 * Auth routes reached from inside the native app.
 *
 * The web layout assumes browser chrome it does not have here: it renders a
 * marketing nav with a menu that leads out of the app, a background watermark
 * sized for a two-column desktop page, and no safe-area padding - so its own
 * header sat under the status bar. Any route the sheet navigates to (reset
 * password, update password) landed on that.
 *
 * This is the entry paper instead, the same surface the welcome screen and the
 * sign-in sheet use, with the insets the device actually has.
 */
export function MobileAuthLayout({ children }: MobileAuthLayoutProps) {
  // These routes live OUTSIDE MobileShell, so nothing else ever paints the
  // status bar for them. Without this, signing out leaves the home header's
  // light glyphs behind and they sit on cream paper until the next sign-in.
  // `brandCanvasClass` is frozen cream in both themes, so this takes no theme.
  useStatusBarSurface('light');

  return (
    <div
      className={`h-dvh overflow-x-hidden overflow-y-auto overscroll-contain pt-[calc(env(safe-area-inset-top)+16px)] pr-[max(20px,var(--pp-mobile-safe-area-right,env(safe-area-inset-right)))] pb-[calc(env(safe-area-inset-bottom)+20px)] pl-[max(20px,var(--pp-mobile-safe-area-left,env(safe-area-inset-left)))] font-sohne antialiased ${brandCanvasClass}`}
    >
      <div className="mx-auto flex w-full max-w-107.5 flex-col py-8">{children}</div>
    </div>
  );
}
